module.exports = __webpack_public_path__ + "static/img/ptGame.a9823d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/hotGame/ptGame.png
// module id = iswU
// module chunks = 3